import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    footerContainer: {
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center"
    },
    messageSectionContainer: {
        flexDirection: "column"
    },
    closeButton: {
        ...webStyle({
            cursor: "pointer"
        })
    },
    infoRow: {
        flexDirection: "row",
        alignItems: "center"
    },
    messageCardContainer: {
        borderWidth: 1
    },
    senderCardContainer: {
        borderWidth: 1
    },
    container: {
        maxWidth: "92%",
        width: 600
    },
    contentContainer: {
        maxHeight: 480
    }
});
export default stylesheet;
